import {
  VIEW_ALL_PARAM,
  VIEW_ALL_NEXT_PARAM
} from 'constant'

import {
  GLOBAL_SEARCH_RESULT_URL_PATH,
  RECORDS_PER_PAGE,
  GLOBAL_TIRE_SEARCH_REGEX
} from './constants'

const getAllResultsNextPath = ({ pathname = '' }) =>
  GLOBAL_TIRE_SEARCH_REGEX.test(pathname) ?
    pathname.replace(GLOBAL_TIRE_SEARCH_REGEX, GLOBAL_SEARCH_RESULT_URL_PATH) : GLOBAL_SEARCH_RESULT_URL_PATH

export const getAllResultsNextQuery = ({ search = '', index = 12 } = {}) =>
  search ? `${search}&${VIEW_ALL_NEXT_PARAM}=${index}&${VIEW_ALL_PARAM}=${RECORDS_PER_PAGE}` :
    `?${VIEW_ALL_NEXT_PARAM}=${index}&${VIEW_ALL_PARAM}=${RECORDS_PER_PAGE}`

export const getAllResultsNextRequestUrl = ({ pathname = '', search = '', index } = {}) =>
  `${getAllResultsNextPath({ pathname })}${getAllResultsNextQuery({ search, index })}`

export const getSearchUrlValue = (navigationState) => {
  const splittedFilterUrl = navigationState.split('&')
  const searchQueryUrlList = splittedFilterUrl[splittedFilterUrl.length - 1].split('=')

  return searchQueryUrlList[searchQueryUrlList.length - 1]
}
